export const ROUTER_URL = {
  HOME: '/',
  THERAPEUTIC_TYPES: 'therapeutic-types',
  PRODUCTS: 'products',
  SEARCH_RESULTS: 'search-results',
  ERROR: 'error',
};
